const coreValues = [
  {
    icon: 'ri-heart-pulse-line',
    title: '情感共鸣',
    desc: '掌中的美母触动每个人内心最深处的柔软，唤醒对爱与关怀的本能感知，建立起跨越时空的心灵连接。',
  },
  {
    icon: 'ri-ancient-gate-line',
    title: '文化传承',
    desc: '延续千年中华文化中母性崇拜的精髓，将传统文化基因融入当代生活，让经典焕发新生。',
  },
  {
    icon: 'ri-shield-star-line',
    title: '精神力量',
    desc: '在快节奏的现代生活中提供一片宁静的精神栖息地，给予面对挑战的勇气和前行的力量。',
  },
  {
    icon: 'ri-hand-heart-line',
    title: '温暖陪伴',
    desc: '无论何时何地，掌中的美母都像一位温柔的母亲，用无声的陪伴抚慰每一颗需要关怀的心。',
  },
];

export default function CoreValueSection() {
  return (
    <section className="py-20 md:py-28 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-14">
          <p className="text-sm text-accent-600 font-medium tracking-widest mb-3">
            核心价值
          </p>
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-heading text-foreground-900 mb-4">
            掌中的美母，不只是一件物品
          </h2>
          <p className="text-foreground-600 max-w-2xl mx-auto text-sm md:text-base leading-relaxed">
            它承载着深厚的情感与文化，是现代生活中不可或缺的精神寄托。以下四大核心价值，诠释了掌中的美母的独特魅力。
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {coreValues.map((item, idx) => (
            <div
              key={idx}
              className="bg-background-50 rounded-lg p-6 md:p-7 text-center group hover:bg-accent-50/30 transition-colors duration-300"
            >
              <div className="w-14 h-14 mx-auto mb-5 flex items-center justify-center rounded-full bg-accent-100 text-accent-600 group-hover:bg-accent-200 transition-colors duration-300">
                <i className={`${item.icon} text-xl`}></i>
              </div>
              <h3 className="text-base font-heading text-foreground-900 mb-3">{item.title}</h3>
              <p className="text-sm text-foreground-600 leading-relaxed">{item.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}